module.exports = __webpack_public_path__ + "static/media/pushback_arrow.ca960295.png";